import React from "react";
import AcademiesContent from "../FunctionComponents/AcademiesFolderOld/AcademiesContent";

function AcademiesOld() {
  return (
    <>
      <AcademiesContent />
    </>
  );
}

export default AcademiesOld;
